import React from 'react';

export type FlashMessageProps = {
  message: string;
  seconds: number;
  hideFlash: string;
};

const FlashMessage: React.FC<FlashMessageProps> = ({
  message,
  seconds,
  hideFlash,
}) => {
  const timeoutRef = React.useRef<any>();

  React.useEffect(() => {
    if (seconds > 0) {
      timeoutRef.current = setTimeout(hideFlash, 1000 * seconds);
    }
    return () => clearTimeout(timeoutRef.current as NodeJS.Timeout);
  }, [seconds]);

  return <div className="flashMessage">{message}</div>;
};

export default FlashMessage;
